import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ArrowRight, LockKeyhole, UserPlus, X as IconX } from 'lucide-react';
import '../../styles/pages/auth5.css';

/**
 * Conversion gate used at the end of an anonymous public trip.
 * It deliberately reuses the auth5 modal primitives so this prompt has
 * exactly the same visual language as the login/register experience.
 */
const PublicTripGateModal = ({ open, onClose, redirectTo }) => {
  if (!open) return null;

  return (
    <div
      className="gm-auth5__modal-overlay gm-public-trip-gate"
      role="dialog"
      aria-modal="true"
      aria-labelledby="gm-public-trip-gate-title"
      onClick={onClose}
    >
      <div
        className="gm-auth5__modal-panel"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="gm-auth5__modal-close"
          onClick={onClose}
          aria-label="Fechar"
        >
          <IconX size={20} strokeWidth={1.8} />
        </button>

        <div className="gm-auth5__modal-header">
          <div className="gm-auth5__modal-icon" aria-hidden="true">
            <LockKeyhole size={26} strokeWidth={1.8} />
          </div>
          <h2 id="gm-public-trip-gate-title" className="gm-auth5__modal-title">
            Continua a explorar
          </h2>
          <p className="gm-auth5__modal-sub">
            Cria uma conta ou inicia sessão para explorares mais viagens,
            partilhares as tuas experiências e ajudares outros viajantes.
          </p>
        </div>

        <div className="gm-auth5__modal-actions">
          <Link
            to="/register"
            state={redirectTo ? { from: redirectTo } : undefined}
            className="gm-auth5__btn gm-auth5__btn--primary"
            onClick={onClose}
          >
            <UserPlus size={17} strokeWidth={2} />
            Criar conta
            <ArrowRight size={16} strokeWidth={2} />
          </Link>
          <Link
            to="/login"
            state={redirectTo ? { from: redirectTo } : undefined}
            className="gm-auth5__btn gm-auth5__btn--ghost"
            onClick={onClose}
          >
            Iniciar sessão
          </Link>
        </div>
      </div>
    </div>
  );
};

PublicTripGateModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  redirectTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

PublicTripGateModal.defaultProps = {
  open: false,
  redirectTo: null,
};

export default PublicTripGateModal;
